import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.496.04A3.001 3.001 0 0 0 7 3v11.234l-2.43-1.458a2.946 2.946 0 0 0-3.599 4.61L7.586 24h13.272l1.7-11.051a4 4 0 0 0-3.116-4.52L13 7.05V3.107c0-1.411-.966-2.816-2.504-3.066ZM9 3c0-.607.54-1.089 1.175-.985.429.07.825.511.825 1.092v5.559l8.023 1.72a2 2 0 0 1 1.558 2.259L19.141 22H8.415l-6.028-6.028a.946.946 0 0 1 1.155-1.48L9 17.765V3Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23.268 3.36c-1.42-1.704-3.25-2.537-4.681-2.946a11.26 11.26 0 0 0-1.81-.36A9.018 9.018 0 0 0 16.022 0H16v1-1h-1v2h1.021a7.028 7.028 0 0 1 .53.04c.371.042.893.126 1.487.296 1.193.34 2.614 1.008 3.694 2.304l.64.768 1.536-1.28-.64-.769Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconActionDraw24 = createIcon(IconComponent);